import {type PillType} from '@hm/fundamental'

import {RiaPriority} from '../types'

export const priorityColor: Record<RiaPriority, PillType> = {
  [RiaPriority.A]: 'negative',
  [RiaPriority.B]: 'warning',
  [RiaPriority.C]: 'info'
}
